import React from 'react';
import styled from 'styled-components';
import { Loader } from '../Loader';
const Root = styled.div.withConfig({
  displayName: "BusyOverlay__Root",
  componentId: "sc-21yknn-0"
})(["position:relative;min-height:8rem;"]);
const Overlay = styled.div.withConfig({
  displayName: "BusyOverlay__Overlay",
  componentId: "sc-21yknn-1"
})(["position:absolute;inset:0;z-index:10;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,0.5);"]);
const Content = styled.div.withConfig({
  displayName: "BusyOverlay__Content",
  componentId: "sc-21yknn-2"
})(["", ""], ({
  $busy
}) => $busy ? `
    pointer-events: none;
    user-select: none;
  ` : '');

var _ref = /*#__PURE__*/React.createElement(Overlay, null, /*#__PURE__*/React.createElement(Loader, {
  contained: true
}));

/**
 * Blocks interaction with children while `busy` is true and shows a contained loader.
 */
export const BusyOverlay = ({
  busy,
  children
}) => /*#__PURE__*/React.createElement(Root, {
  "aria-busy": busy || undefined
}, busy && _ref, /*#__PURE__*/React.createElement(Content, {
  $busy: busy
}, children));
export default BusyOverlay;